<template>
  	<div>
		<div class="page-wrapper">
			<article>
				<header class="article-head">
					<div class="article-head__top">
						<ul class="article-details">
							<li class="article-details__item article-details__item--calendar">April 28, 2020</li>
							<li class="article-details__item">Montréal, QC</li>
							<li class="article-details__item">By Lisa Gaetz</li>
						</ul>
						<!--<ul class="social-links">
							<li class="social-links__item">1</li>
							<li class="social-links__item">2</li>
							<li class="social-links__item">3</li>
							<li class="social-links__item">4</li>
						</ul>-->
					</div>
					<h1 class="title title--main">Heartland MLS Partners with Prospects Software to Deliver Premium Mobile App </h1>
				</header>
                <p>MONTREAL, QC, and LEAWOOD, KS, April 28, 2020 – Prospects Software, a provider of premium agent productivity and marketing solutions, announced today an agreement with Heartland MLS to bring its widely adopted MLS-Touch mobile MLS app to the Kansas City Metro’s 11,000+ agents, as a subscriber benefit. </p>
                <p>MLS-Touch, available for iOS and Android devices, offers advanced listing searches, contact and lead management, agent-branded consumer apps, market stats, hotsheets, comparables, automatic Facebook publishing, and seamless integrations with CoreLogic Matrix™, the most widely used multiple listing platform in the industry. It is also integrated with Realist® tax data and ShowingTime. Upon launch, the app will be available to Heartland subscribers at no additional cost and with no upselling. </P>
                <p>“We’re really looking forward to making this app available to our subscribers,” said Kipp Cooper, CEO of Heartland MLS and KCRAR. “The first time we saw it, we knew that MLS-Touch was a best-of-breed tool that our agents needed to have. It gives them extensive Matrix capabilities in the palm of their hand and a host of powerful features that create efficiencies and will help them raise the bar with their customer engagements and the level of service they provide.” </p>
                <p>Prospects Software now provides solutions to over 300,000 real estate brokers and agents across North America. The new app will be available to Heartland MLS subscribers in July. </p>
                <p>“It’s an honor to have our mobile app selected by Heartland MLS,” said Charles Drouin, CEO of Prospects Software. “We first launched MLS-Touch almost 10 years ago, and we continue to innovate daily to make sure it’s always providing what agents need as the industry evolves. We’re thrilled to make MLS-Touch available to Heartland MLS subscribers.” </p>
                <h3 class="title title--sub">About Heartland MLS  </h3>
                <p>Heartland MLS, a subsidiary of the Kansas City Regional Association of REALTORS® (KCRAR), is one of the largest MLSs in the country serving 11,000+ members and subscribers in Kansas and Missouri. Heartland MLS is the source of listings for REALTORS® in 37 counties in the Greater Kansas City Region. For more information, visit <a  class="link" href="http://kcrar.com/" target="_blank">www.kcrar.com</a>.  </p>
					<h3 class="title title--sub">About Prospects Software</h3>
                <p>Prospects Software provides two of the most critical tools that real estate professionals rely on every day beyond their primary MLS - mobile MLS and CRM. MLS-Touch, also known as Prospects Mobile in Canada, keeps agents connected to listings, leads, and contacts from anywhere, on any device. Prospects CRM gives agents a powerful tool to organize contacts and manage customer relationships. Prospects apps are intelligent, easy-to-use, and fully integrated with each other and with the CoreLogic Matrix multiple listing platform. For more information, visit <br><a href="https://www.prospects.com/en/ca/home" class="link" target="blank">www.prospects.com</a>.</p>
			<footer class="article-foot">
					<h3 class="title title--sub">Press Contact</h3>
					<p>Lisa Gaetz<br>Director of Marketing<br><a href="mailto:lisa@prospects.com"  class="link" >lisa@prospects.com</a><br>Phone: <a  class="link" href="phone:8887659223">(888) 765-9223 ext.207</a></p>
				</footer>
			</article>
		</div>
  	</div>
</template>


<script>
import Introducer from '@/components/utils/Introducer.vue'

export default {
	components: { Introducer },

	mounted () {
	},

	data () {
		 return {
		 }
	},

	computed: {

	},

	methods: {
	}
};
</script>

<style lang="scss">
	@import url('https://fonts.googleapis.com/css?family=Libre+Baskerville:400i&display=swap');

	$quote-font: 'Libre Baskerville', serif;
	$news-font : 'Montserrat', sans-serif;

	//breakpoints
	$screen-sm: 576px;
	$screen-md: 768px;
	$screen-lg:	992px;
	$screen-xl:	1280px;

	//breakpoints mixin

	@mixin media-breakpoint-up($class) {

	  @if $class == sm {
	    @media (min-width: $screen-sm) { @content; }
	  }

	  @else if $class == md {
	    @media (min-width: $screen-md) { @content; }
	  }

	  @else if $class == lg {
	    @media (min-width: $screen-lg) { @content; }
	  }

	   @else if $class == xl {
	    @media (min-width: $screen-xl) { @content; }
	  }

	  @else {
	    @warn "Breakpoint mixin supports: xs, sm, md, lg";
	  }
	}
//main article font
@mixin newsFont($colour: false, $size: false, $weight: false,  $lh: false) {
    font-family: $news-font, Helvetica, Arial, sans-serif;
    //@if $size { font-size: $size; }
    @if $colour { color: $colour; }
    @if $size { font-size: $size; }
    @if $weight { font-weight: $weight; }
    @if $lh { line-height: $lh; }
}

	.article-head {
		margin: 40px 0;
		padding: 0 0 20px;
		border-bottom: 1px solid #ccc;
	}
	.article-head__top {
		display: flex;
		justify-content: space-between;
	}
	.article-details {
		list-style-type: none;
		display: flex;
		margin-bottom: 2em;
		@include newsFont (#000, 12px, 400, 18px);
		@include media-breakpoint-up(sm) {
			@include newsFont (#000, 16px, 400, 20px);
		}
	}
	.article-details__item {
		margin-right: 1em;
		display: flex;
		&:after {
			content: '|';
			margin-left: 1em;
		}
		&:last-child {
			&:after {
				content: none;
			}
		}
		&--calendar {
			&:before {
				content: url(./../../assets/calendar.svg);
				width: 17px;
				height: 17px;
				margin-right: 10px;
			}
		}
	}
	.social-links {
		list-style-type: none;
		display: flex;
	}
	.social-links__item {
		margin-left: 10px;
	}
	.title {
		margin-bottom: 1em;
	}
	.title--main {
		@include newsFont (#000, 20px, 500, 30px);
		text-transform: uppercase;
		margin-bottom: 1em;
		@include media-breakpoint-up(sm) {
			@include newsFont (#000, 27px, 200, 40px);
		}
		@include media-breakpoint-up(lg) {
			@include newsFont (#000, 48px, 200, 52px);
			width: 75%;
		}
	}
	.title--secondary {
		@include newsFont (#000, 22px, 400, 26px);
	}
	.title--sub {
		@include newsFont (#000, 18px, 700, 20px);
	}
	.link {
		color: #e02428;
		word-break: break-all;
		font-weight: 400;
	}
	.link--hidden {
		color: #000;
	}
	p {
		margin-bottom: 2em;
		line-height: 1.5;
		font-weight: 300;
	}
	.quote {
		display: flex;
		font-weight: 300;
		line-height: 2em;
		margin-left: 0;
		margin-bottom: 40px;
		margin-top: 0;
	}

	.copyright {
		@include newsFont (#000, 14px, 400, 20px);
		font-style: italic;
	}
	.article-foot {
		background: #f7f7f7;
		padding: 30px 30px 5px;
		margin-bottom: 25px;
	}
</style>
